import createSuccessPromiseThunk from "~/rx/lib/createSuccessPromiseThunk";
import createModelApi from "~/backend/modelApi";
import {
    getDataActionPermissions, getItemId, getModelName, getPrimaryKeyAttr,
} from "~/stateGetter";
import {mockupCancel} from "~/data/cancelToken";
import identify from "~/identify";
import {presentPrimaryKey} from "~/statePresenter";
import {modify} from "mythil/object";
import setItemDataValue from "~/reducers/helpers/setItemDataValue";
import {prepareItemData} from "~/data/dataPreparer";
import authenticatedRequest from "~/backend/authenticatedRequest";


let item = createSuccessPromiseThunk({
    func: async ({cancel = mockupCancel, modelId, itemId, getState, getConfig, dispatch}) => {
        let state = getState(),
            modelApi = createModelApi(
                getConfig().baseUrl,
                getModelName(state, modelId),
                (foo) => authenticatedRequest(foo, dispatch)
            );

        itemId = itemId ? itemId : getItemId(state, modelId);

        if(!itemId || itemId === identify.NEW_ITEM) {
            throw new Error('Cant fetch empty or new item.');
        }

        let unpreparedItemData =  await modelApi.fetchItem(itemId, cancel);

        return prepareItemData(unpreparedItemData);
    },
    name: 'fetchItem',
});

item.actions.setValue = (value, {modelId}) => {
    return (dispatch, getState) => {
        let state = getState();

        if(value.itemId !== identify.NEW_ITEM) {
            let primaryKeyAttr = getPrimaryKeyAttr(state, modelId);
            value.itemId = presentPrimaryKey({ values: value.values, primaryKeyAttr, defaultKey: value.itemId });
        }

        return dispatch({ type: item.types.SUCCESS, value, modelId });
    };
};

let execute = item.execute;
item.execute = (modelId, itemId, cancel) => execute({modelId, cancel, itemId}, {modelId});

let reduce = item.reduce;
item.reduce = (model, action, state) => {
    switch(action.type) {
        case item.types.SUCCESS:
            model = modify(model, 'item.id', action.value.itemId);
            model = setItemDataValue(model, action.value, state);
            model = modify(model, "view", () => {
                const canUpdate = action.value.actionPermissions.update || getDataActionPermissions(state, action.modelId)?.update;
                return canUpdate ? "edit" : "view";
            })
            break;
        default:
            model = modify(model, 'itemData', (state) => reduce(state, action));
            break;
    }

    return model;
};

const reduceFetchItem = item.reduce,
    FETCH_ITEM_TYPES = item.types,
    fetchItem = item.execute,
    setItemValue = item.actions.setValue;

export {
    reduceFetchItem,
    FETCH_ITEM_TYPES,
    fetchItem,
    setItemValue
}

